import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'scheduling',
  initialState: {
    exportDelayedPopup: {
      open: false
    },
    selectedEventTypeIds: [],
    eventTypes: [],
    visibleEventTypeIds: []
  },
  reducers: {
    addEventTypes: (state, { payload }) => {
      const newEventTypeIds = payload.map(({ id }) => id)
      state.eventTypes = [...state.eventTypes.filter(({ id }) => !newEventTypeIds.includes(id)), ...payload]
    },
    updateEventType: (state, { payload }) => {
      const eventType = state.eventTypes.find(({ id }) => id === payload.id)
      if (eventType) {
        Object.assign(eventType, payload.data)
      }
    },
    setVisibleEventTypeIds: (state, { payload }) => {
      state.visibleEventTypeIds = payload
    },
    setSelectedEventTypeIds: (state, { payload }) => {
      state.selectedEventTypeIds = [...payload]
    },
    selectEventType: (state, { payload }) => {
      state.lastSelectedEventType = payload
      state.selectedEventTypeIds = [...state.selectedEventTypeIds, payload.id]
    },
    deselectEventTypeById: (state, { payload }) => {
      state.lastSelectedEventType = null
      state.selectedEventTypeIds = state.selectedEventTypeIds.filter(((id) => id !== payload))
    },
    deselectAllEventTypes: (state) => {
      state.lastSelectedEventType = null
      state.selectedEventTypeIds = []
    },
    setDeleteConfirmationPopupOpen: (state, { payload }) => {
      state.deleteConfirmationPopupOpen = payload
    },
    openExportDelayedPopup: (state) => {
      state.exportDelayedPopup.open = true
    },
    closeExportDelayedPopup: (state) => {
      state.exportDelayedPopup.open = false
    }
  },
})

export const {
  reducer,
  actions: {
    addEventTypes,
    updateEventType,
    setVisibleEventTypeIds,
    setSelectedEventTypeIds,
    setDeleteConfirmationPopupOpen,
    deselectAllEventTypes,
    selectEventType,
    deselectEventTypeById,
    openExportDelayedPopup,
    closeExportDelayedPopup
  }
} = slice
